
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';

  export default defineComponent({
    name: 'indices-property-categories-creating',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(
          translate('indicesPropertyCategoryCreating'),
          [translate('indices')]
        );
      });

      const disablePriceAreas = ref<boolean>(false);
      const disableVolumeAreas = ref<boolean>(false);
      const volumeIndexTicker = ref<boolean>(false);
      const slug = ref<string>('');
      const isActive = ref<boolean>(true);
      const viewFlags = ref({
        price_index_view_active: false,
        volume_index_view_active: false,
        ppm_view_active: false,
        no_of_deals_view_active: false,
      });

      const validationSchema = Yup.object().shape({
        titleAr: Yup.string()
          .required(() => translate('TITLE_AR_IS_REQUIRED_FIELD'))
          .label('Title Ar'),
        titleEn: Yup.string()
          .required(() => translate('TITLE_EN_IS_REQUIRED_FIELD'))
          .label('Title En'),
      });

      const onSubmitCreate = async (values) => {
        if (submitButton.value) {
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }

        const payload = {
          titleAr: values.titleAr,
          titleEn: values.titleEn,
          disablePriceAreas: disablePriceAreas.value,
          disableVolumeAreas: disableVolumeAreas.value,
          volume_index_ticker: volumeIndexTicker.value,
          isActive: isActive.value,
          ...viewFlags.value,
          ...(slug.value ? { slug: slug.value } : {}),
        };

        await store.dispatch(Actions.CREATE_INDICES_PROPERTY_CATEGORY, payload);
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          submitButton.value?.removeAttribute('data-kt-indicator');
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_CREATED_INDICES_PROPERTY_CATEGORY'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'indices-property-categories-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onSubmitCreate,
        submitButton,
        translate,
        validationSchema,
        goBack,
        disablePriceAreas,
        disableVolumeAreas,
        volumeIndexTicker,
        slug,
        isActive,
        viewFlags,
        can,
      };
    },
  });
